
import { Vue, Component, Prop } from 'vue-property-decorator';
import { IProductListProduct } from '@homeserve/od-typings/api';

@Component
export default class WLProductListItem extends Vue {
  @Prop()
  public product!: IProductListProduct;
}
